// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as Modal$PrezzeeRibbon from "../Modal/Modal.bs.js";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as RegionPicker$PrezzeeRibbon from "./RegionPicker.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Layout$PrezzeeRibbon from "../../../theme/Theme__Layout.bs.js";
import * as ReactFontawesome from "@fortawesome/react-fontawesome";
import * as Modal__Container$PrezzeeRibbon from "../Modal/Modal__Container.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";
import * as FaTimes from "@fortawesome/pro-light-svg-icons/faTimes";

var wrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.px(30)),
      BsCssJs$PrezzeeRibbon.maxWidth(BsCssJs$PrezzeeRibbon.px(470)),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobile, [BsCssJs$PrezzeeRibbon.maxWidth(BsCssJs$PrezzeeRibbon.pct(100))])
    ]);

var closeButton = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.charcoal),
      BsCssJs$PrezzeeRibbon.position("absolute"),
      BsCssJs$PrezzeeRibbon.top(BsCssJs$PrezzeeRibbon.px(30)),
      BsCssJs$PrezzeeRibbon.right(BsCssJs$PrezzeeRibbon.px(20)),
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(26)),
      BsCssJs$PrezzeeRibbon.fontWeight({
            NAME: "num",
            VAL: 300
          })
    ]);

var paper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.borderRadius(Theme__Layout$PrezzeeRibbon.Personal.borderRadius)),
      BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.marginLeft(BsCssJs$PrezzeeRibbon.px(20))),
      BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.px(20)))
    ]);

var backdrop = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.backgroundColor(BsCssJs$PrezzeeRibbon.rgba(49, 62, 73, {
                    NAME: "num",
                    VAL: 0.9
                  })))]);

var Styles = {
  wrapper: wrapper,
  closeButton: closeButton,
  paper: paper,
  backdrop: backdrop
};

function RegionPickerDialog(props) {
  var onClose = props.onClose;
  var onSave = props.onSave;
  var isOpen = props.isOpen;
  var selected = props.selected;
  var selected$1 = selected !== undefined ? selected : 0;
  var isOpen$1 = isOpen !== undefined ? isOpen : false;
  var onSave$1 = onSave !== undefined ? onSave : (function (param) {
        
      });
  var onClose$1 = onClose !== undefined ? onClose : (function (param) {
        
      });
  var match = React.useState(function () {
        return false;
      });
  var setModalOpen = match[1];
  var onRequestClose = function (param) {
    Curry._1(setModalOpen, (function (param) {
            return false;
          }));
  };
  return JsxRuntime.jsx(Modal$PrezzeeRibbon.make, {
              children: JsxRuntime.jsxs(Modal__Container$PrezzeeRibbon.make, {
                    id: "modal-reigon",
                    isOpen: isOpen$1,
                    onRequestClose: onRequestClose,
                    children: [
                      JsxRuntime.jsx(RegionPicker$PrezzeeRibbon.make, {
                            regions: props.regions,
                            strings: props.strings,
                            selected: selected$1,
                            onSave: onSave$1
                          }),
                      JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
                            icon: FaTimes.faTimes,
                            className: closeButton,
                            onClick: (function (param) {
                                Curry._1(onClose$1, undefined);
                              })
                          })
                    ],
                    borderless: false,
                    className: wrapper
                  })
            });
}

var make = RegionPickerDialog;

export {
  Styles ,
  make ,
}
/* wrapper Not a pure module */
